import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

export const fields = ['username', 'password'];

class SingleSignOnLoginForm extends Component {
  componentDidMount() {
    const queryString = window.location.search;
    // note: this doesn't allow for other querystring items yet
    const singleSignOnId = queryString.substring(queryString.indexOf('id=') + 3);
    this.props.handleLogin(singleSignOnId);
  }

  render() {
    return (
      <div>
      </div>
    );
  }
}

SingleSignOnLoginForm.propTypes = {
  handleLogin: PropTypes.func.isRequired,
};

export default connect()(injectIntl(SingleSignOnLoginForm));
